import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const MedalIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12 15C15.73 15 18.75 12.03 18.75 8.37C18.75 4.7 15.73 1.75 12 1.75C8.27 1.75 5.25 4.71 5.25 8.37C5.25 12.03 8.27 15 12 15Z"
		/>

		<path
			opacity={0.4}
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M7.52 13.52L7.51 20.9C7.51 21.8 8.14 22.24 8.92 21.87L11.6 20.6C11.82 20.49 12.19 20.49 12.41 20.6L15.1 21.87C15.87 22.23 16.51 21.8 16.51 20.9V13.34"
		/>

		<path
			opacity={0.4}
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12 5.5L12.8 7.1L14.5 7.35L13.25 8.55L13.55 10.25L12 9.45L10.45 10.25L10.75 8.55L9.5 7.35L11.2 7.1L12 5.5Z"
		/>
	</SvgIcon>
)

export default MedalIconAtom
